import logo from "./logo.svg";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
// import Inventory from "./pages/Inventory";
import Logout from "./pages/Logout";
import Chat from "./pages/Chat";
import Initial from "./pages/Initial";
import Flight from "./pages/Flight";
import Trees from "./pages/Trees";
import Test from "./pages/Test";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/" element={<Initial />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/flight" element={<Flight />} />
        <Route path="/trees" element={<Trees />} />
        <Route path="/album" element={<Test />} />
      </Routes>
    </div>
  );
}

export default App;
